<template>
  <div>
    <div class="score-area">
      <p><b>Applicant Score:</b> {{ applicant_total_score }}</p>
      <p><b>Score Percentage:</b> {{ score_percent }}%</p>
      <p><b>Total Test Score:</b> {{ question_total_score }}</p>
    </div>
    <div v-for="(question, index) in submission" class="single_question">
      <blockquote class="blockquote">
        <b>Question {{ index + 1 }}</b>
        <p>{{ question.questioncontent }}</p>
      </blockquote>
      <div class="answers" v-if="question.questiontype !== 'lt'">
        <span v-if="scores[index].score > 0" class="correct_answer">
          <span>+ {{ scores[index].score }}</span>
        </span>
        <span v-else class="wrong_answer">
          <i class="ti-close"></i>
        </span>
        &nbsp;&nbsp;
        <button
          class="btn btn-outline-primary btn-sm"
          data-toggle="modal"
          v-bind:data-target="'#answer_modal_' + question.question_id"
        >
          View Answers
        </button>
      </div>
      <div v-else>
        <div>
          <button
            class="btn btn-outline-warning btn-sm"
            data-toggle="modal"
            v-bind:data-target="'#answer_modal_' + question.question_id"
          >
            View Applicant Answer
          </button>
        </div>

        <!-- <label class="mt-2">Score: </label>
				<input type="number" v-bind:max="question.score" class="form-control" /> -->
      </div>
    </div>

    <div
      v-for="(question, qindex) in submission"
      v-bind:id="'answer_modal_' + question.question_id"
      class="modal fade"
      role="dialog"
    >
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Question {{ qindex + 1 }}</h5>
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="answers">
              <div
                class="question_answers"
                v-if="
                  question.questiontype == 'ma' ||
                    question.questiontype == 'sa' ||
                    question.questiontype == 'oa'
                "
              >
                <b>Correct Answer(s): </b>
                <ul>
                  <li v-for="answer in question.answers">
                    {{ question.options[answer] }}
                  </li>
                </ul>

                <b>Applicant Answer(s): </b>
                <ul>
                  <li v-for="answer in question.applicant_answer">
                    {{ question.options[answer] }}
                  </li>
                </ul>
              </div>
              <div
                class="question_answers"
                v-else-if="question.questiontype == 'sj'"
              >
                <b>Correct Answer:</b>
                <ul>
                  <li v-for="(tag, tag_index) in question.answer_tags">
                    <u>{{ tag }}:</u>
                    {{ question.options[question.answers[tag_index]] }}
                  </li>
                </ul>

                <b>Applicant Answer:</b>
                <ul>
                  <li v-for="(tag, tag_index) in question.answer_tags">
                    <u>{{ tag }}:</u>
                    {{ question.options[question.applicant_answer[tag_index]] }}
                  </li>
                </ul>
              </div>
              <div
                class="question-answers"
                v-else-if="question.questiontype == 'st'"
              >
                <b>Correct Answer(s): </b>
                <ol>
                  <li v-for="answer in question.answers">{{ answer }}</li>
                </ol>

                <b>Applicant Answer(s): </b>
                <ol>
                  <li v-for="answer in question.applicant_answer">
                    {{ answer }}
                  </li>
                </ol>
              </div>
              <div
                class="question-answers"
                v-else-if="question.questiontype == 'lt'"
              >
                <b>Applicant Answer:</b>
                <p>{{ question.applicant_answer[0] }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.accordion-msg {
  padding: 14px 20px 14px 0px !important;
  border-top: 0px !important;
}
.single_question {
  border: 1px solid #ccc;
  padding: 20px;
  border-radius: 5px;
  margin-top: 20px;
}
.correct_answer i {
  color: #00ff00;
  font-weight: 600;
  font-size: 30px;
}
.correct_answer span {
  font-size: 20px;
  color: #00ff00;
}
.wrong_answer i {
  color: #ff0000;
  font-weight: 600;
  font-size: 25px;
  border: 1px solid #ff0000;
  border-radius: 50%;
  padding: 5px;
}
.score-area p {
  font-size: 17px;
}
</style>

<script>
export default {
  name: "ApplicantCBT",
  props: {
    applicant_id: {
      required: true,
    },
  },
  data() {
    return {
      submission: [],
      scores: [],
      question_total_score: "",
      applicant_total_score: "",
      score_percent: "",
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init: function() {
      this.getCbtAnswers(this.applicant_id);
    },

    getCbtAnswers: function(applicant_id) {
      let request = {
        what: "GetApplicantCBT",
        params: {
          applicant_id: applicant_id,
        },
      };

      this.$socket
        .makeGetRequest(request)
        .then((response) => {
          if (response.type == "GetApplicantCBT") {
            this.submission = response.data;
            this.scoreAnswers(this.submission);
            this.$swal.close();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    scoreAnswers: function(question) {
      /*
					This functions, depending on the question type, compares the applicant answers with the question 
					answers and creates an array of the scores.
					AA = Applicant Answer
					QA = Question Answer
				*/

      let question_count = question.length;

      //console.log(question[0])

      for (var i = 0; i < question_count; i++) {
        switch (question[i].questiontype) {
          case "oa":
          case "sa":
            /*
								For these tests, we want to check if the AA vs QA values at the same
								indexes tally. If all values tally, the applicant
							*/
            if (
              JSON.stringify(question[i].applicant_answer).toLowerCase() ==
              JSON.stringify(question[i].answers).toLowerCase()
            ) {
              this.scores[i] = {
                score: parseInt(question[i].score),
              };
            } else {
              this.scores[i] = {
                score: 0,
              };
            }
            break;
          // ...existing code...
          case "ma":
            var score = parseInt(question[i].score);
            var qa = (question[i].answers || []).filter((a) => a !== null);
            var qa_len = qa.length;
            var each_input = qa_len > 0 ? score / qa_len : 0;
            var aa = question[i].applicant_answer || [];
            var temp_score = 0;

            for (var j = 0; j < qa_len; j++) {
              if (aa.includes(qa[j])) {
                temp_score++;
              }
            }

            this.scores[i] = {
              score: temp_score * each_input,
            };
            break;
          case "st":
          case "sj":
            var score = parseInt(question[i].score);

            // ✅ Filter nulls BEFORE calculating length
            var qa = (question[i].answers || []).filter((a) => a !== null);
            var qa_len = qa.length;

            var input_count = parseInt(question[i].inputs);
            if (isNaN(input_count) || input_count <= 0) {
              input_count = qa_len;
            }
            var each_input = input_count > 0 ? score / input_count : 0;
            var aa = question[i].applicant_answer || [];
            var aa_len = aa.length;
            var temp_score = 0;

            if (qa_len === aa_len && aa_len > 0) {
              for (var j = 0; j < aa_len; j++) {
                if (aa[j] == qa[j]) {
                  temp_score++;
                }
              }
              this.scores[i] = { score: temp_score * each_input };
            } else {
              this.scores[i] = { score: 0 };
            }
            break;
          default:
            this.scores[i] = {
              score: 0,
            };
            break;
        }
      }

      this.applicant_total_score = this.calculateTotal(this.scores, "score");
      this.question_total_score = this.calculateTotal(question, "score");
      this.score_percent = parseFloat(
        (this.applicant_total_score * 100) / this.question_total_score,
      ).toFixed(2);
    },

    calculateTotal: function(score_array, key) {
      let total = 0;
      let sa_length = score_array.length;

      for (var i = 0; i < sa_length; i++) {
        total = total + parseInt(score_array[i][key]);
      }

      return total;
    },
  },
};
</script>
